// extracted by mini-css-extract-plugin
export default {"label":"styled_label__cpbID","input":"styled_input__gdlO8","error_text":"styled_error_text__qCqO5"};